import type { ReactNode } from 'react'

import { Button, Flex, Heading, Paragraph, Popover } from '@buffer-mono/popcorn'

import styles from './LinkedInVerifiedSkills.module.css'

type ChooseCapabilityPopoverProps = {
  children: ReactNode
  isEnabled: boolean
  isOpen: boolean
  onOpenChange: (isOpen: boolean) => void
}

const ChooseCapabilityPopover = ({
  children,
  isEnabled,
  isOpen,
  onOpenChange,
}: ChooseCapabilityPopoverProps): React.JSX.Element => {
  return (
    <Popover
      open={isEnabled && isOpen}
      onOpenChange={(nextIsOpen): void => {
        if (isEnabled) {
          onOpenChange(nextIsOpen)
        }
      }}
    >
      <Popover.Anchor>
        <span className={styles.capabilityPopoverAnchor}>{children}</span>
      </Popover.Anchor>
      {isEnabled ? (
        <Popover.Content
          align="end"
          arrow={true}
          className={styles.capabilityPopoverContent}
          side="top"
          size="medium"
        >
          <Flex direction="column" gap="md">
            <Flex direction="column" gap="xs">
              <Heading as="h4" size="sm">
                First choose which Capability to show
              </Heading>
              <Paragraph>
                The Buffer Capability you select will be shown on your LinkedIn
                profile.
              </Paragraph>
            </Flex>
            <Flex align="center" gap="sm" justify="end" fullWidth>
              <Button onClick={(): void => onOpenChange(false)} size="small">
                Got It
              </Button>
            </Flex>
          </Flex>
        </Popover.Content>
      ) : null}
    </Popover>
  )
}

export { ChooseCapabilityPopover }
